import React, {useState, useRef, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Menu } from 'primereact/menu';
import { utils, write } from "xlsx";
import Papa from "papaparse";
import moment from "moment"

import { DropDownField, TextInputField, MultiSelectField } from "../../../helpers";
import Button from "../../../helpers/Button";
import Loading from "../../../common/Loading";
import DateFilter from "../../../common/DateFilter";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchMaterialProductRequestData, updateSearchParams, updateSearchOptions, setSearchConfig } from "../../../services/redux/reducers/materialMaster/materialMasterTemp";
import { downloadMaterialMasterData } from "../../../services/api/materialMaster";

import { getFullName, getAddFilterOptions, getMatchedRegexPattern, normalizeLabel, getDateRange } from "../../../utils";
import { DATE_TIME_FORMAT } from "../../../constants";


const materialMasterTempSearchConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Pending Material Master', value: 'materialMasterTemp' }
        ]
    },
    {   srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
        
    },
    {
        srNO: 3,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "materialId",
        label:"Material Id",
        isValid: (text) => /^[89]\d{6}$|^[1237]\d{5}$/.test(text)
    },
    // {
    //     srNO: 4,
    //     static: true,
    //     type: "DATE",
    //     name: "dateType",
    //     label: "Date",
    //     options: [
    //         { label: 'Created Date', value: 'createdAt' }
    //     ]
    // }
    {
        srNO: 5,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label:"Doc No"
    },
    {
        srNO: 6,
        static: false,
        type: "MULTISELECT",
        name: "categoryIds",
        label: "Categories",
        options: ""
    },
    {
        srNO: 7,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "brandName",
        label:"Brand Name",
    },
    {
        srNO: 8,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "productName",
        label:"Product Name",
    },
    {
        srNO: 9,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "variantName",
        label:"Variant Name",
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "productSpecification",
        label:"Product Specification",
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "keyword",
        label:"Keyword",
    },
]

const MaterialPendingRequestSearchBar = (props) =>{
    const dispatch = useDispatch()

    const [isLoaderVisible, setIsLoaderVisible] = useState(false)

    const paginationParams = useSelector(state => state.requirements.paginationParams)
    const searchParams = useSelector(state => state.materialMasterTemp.searchParams)
    const searchOptions = useSelector(state => state.materialMasterTemp.searchOptions)
    const materialCategory = useSelector((state) => state.common.materialCategories)
    const isPageLoading = useSelector(state => state.materialMasterTemp.loading)
    const materialBrands = useSelector((state) => state.common.materialBrands)

    const materialCategories = materialCategory.map((eachCategory) => eachCategory.categoryName)

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)

    const searchConfig = materialMasterTempSearchConfig

    const [selectCategories, setSelectCategories] = useState([])
    const [isSelectedCategories, setIsSelectedCategories] = useState(false)

    useEffect(() => {
        dispatch(setSearchConfig(materialMasterTempSearchConfig))
        if (searchOptions.length === 0) {
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    useEffect(() => {
        if (searchTextRef.current) {
            searchTextRef.current.focus()
        }
    }, [searchParams.searchBy])


    const addFilterOption = (srNO) => {
        const relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        if(relatedConfig.name === "categoryIds"){
            setIsSelectedCategories(true)
        }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = {...searchParams}

        if(relatedSearchOption.type === "SEARCH_BY"){
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "SELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "MULTISELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
            setIsSelectedCategories(false)
        }

        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        if (relatedSearchOption.type === "DATE") {
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            updatedSearchParams.dateType = ""

            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value
        
        let updatedSearchParams = { ...searchParams, [event.target.name]: eventValue }

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }

        dispatch(updateSearchParams(updatedSearchParams))

        if(event.target.name === "searchText"){
            const availableOptions = [...materialMasterTempSearchConfig]
            const matchText = eventValue.split(";")[0]
            const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
            updatedSearchParams = {...updatedSearchParams, searchBy: matchedPattern}
        }
        
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const downloadData = async (dataFormat) => {
        setIsLoaderVisible(true)
        const response = await downloadMaterialMasterData({...searchParams, paginator: false, limitedPagination: false})
        
        if(response.failure){
            setIsLoaderVisible(false)
            return dispatch(raiseToast({severity:'error', detail: response.data.error , life: 3000}))
        }

        const responseData = response.data.data

        if (responseData.length === 0) {
            setIsLoaderVisible(false)
            return dispatch(raiseToast({ severity: 'warn', detail: "No data found", life: 3000 }))
        }

        let materialMasterData = []
        responseData.map(eachMaterialItem => {
            let relatedCategory = materialCategory.find(eachCategory => eachCategory.categoryId === eachMaterialItem.categoryId)
            let relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === eachMaterialItem.brandId)
            let raisedByUsername = "Migrated"
            if(eachMaterialItem['raisedBy.firstName']){
                raisedByUsername = getFullName(eachMaterialItem['raisedBy.firstName'], eachMaterialItem['raisedBy.lastName'])
            }
            let materialItemObj ={
                "MaterialId": eachMaterialItem.materialId,
                "RaisedBy": raisedByUsername,
                "Category": relatedCategory ? relatedCategory.categoryName : "Unknown",
                "Product Name": eachMaterialItem.productName,
                "Variant Name": eachMaterialItem.variantName,
                "Product Specification": eachMaterialItem.productSpecification,
                "Brand": relatedBrand ? relatedBrand.brandName : "",
                "UOM": eachMaterialItem.UOM,
                "UOMValue": eachMaterialItem.UOMValue,
                "CreatedBy": getFullName(eachMaterialItem['createdBy.firstName'], eachMaterialItem['createdBy.lastName']),
                "CreatedAt": moment(eachMaterialItem.createdAt).format(DATE_TIME_FORMAT),
                "Remarks": eachMaterialItem.remarks ? eachMaterialItem.remarks : null,
                "Keywords": eachMaterialItem.Keywords,
                "Partial Specs Only": eachMaterialItem.partialSpecsOnly,
                "StatusId": eachMaterialItem.statusId,
                "Product Description": eachMaterialItem.productDescription,
                "Material Image": eachMaterialItem.materialImage,
                "Thumbnail Image": eachMaterialItem.thumbnailImage,
                "Product SpecificationJSON": eachMaterialItem.productSpecificationJSON,
            }

            materialMasterData.push(materialItemObj)
        })
        
        if(dataFormat === "CSV"){
            let csv = Papa.unparse(materialMasterData, { download: true })
            let blob = new Blob([csv])
            let a = window.document.createElement("a")
            a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
            a.download = "materialMaster.csv"
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
        if(dataFormat === "XLSX"){
            const ws = utils.json_to_sheet(materialMasterData)
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, 'Sheet1')
            const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'materialMaster.xlsx'
            a.click()
            URL.revokeObjectURL(url)
        }
        setIsLoaderVisible(false)
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadData("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadData("CSV")
        }
    ]

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    } 

    const handleSearch = () => {
        let errorFound = false

        if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
            dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: "Please enter search text" }))
            errorFound = true
        } 
        else if (searchParams.searchText && searchParams.searchBy !== "all"){
            const relatedSearchOption = searchConfig.find(eachOption => eachOption.name === searchParams.searchBy)
            if(relatedSearchOption.isValid && !relatedSearchOption.isValid(searchParams.searchText.split(";")[0])){
                dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: `Please enter valid ${normalizeLabel(searchParams.searchBy).toLowerCase()}` }))
                errorFound = true
            }
        }
        
        searchOptions.map(eachOption => { 
            if (["TEXT", "SELECT", "AUTO_COMPLETE"].includes(eachOption.type)) {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)
    
                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                } else {
                    if(eachOption.isValid && !eachOption.isValid(searchParams[eachOption.name].split(";")[0])){
                        const errorMsgText = normalizeLabel(eachOption.label)
                        dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter valid ${errorMsgText.toLowerCase()}` }))
                        errorFound = true
                    }
                }
            } 
        })

        const updatedSearchParams = {...searchParams}

        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        if(isSelectedCategories === true){
            if(selectCategories.length === 0){
                return dispatch(raiseToast({severity:'error', summary: 'Categories', detail: "Select upto 1 category" , life: 3000}))
            }
        }

        if(!errorFound){
            dispatch(fetchMaterialProductRequestData({...paginationParams, ...updatedSearchParams, pageNo: 0 }))
        }
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const handleInputChange = (event) => {
        setSelectCategories(event.target.value)
        const updatedSearchParams = {...searchParams, categoryIds: event.target.value }
        dispatch(updateSearchParams(updatedSearchParams))
    }
    
    return(
        <div className="p-card" style={{border:"1px solid #e9ecef"}} onKeyDown={handleSearchKeyPress}>
            <div className="grid"> 
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_TEXT") {
                            let searchByOptions = [{label: 'No Filters', value: 'all'}]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })
    
                            return (
                                <>
                                    <div className="flex flex-column col-12">
                                            <TextInputField
                                                name="searchText"
                                                labelText="Search Text"
                                                placeholder="No Filter"
                                                refName={searchTextRef}
                                                value={searchParams["searchText"]}
                                                onChange={handleSearchOnChange}
                                            />
                                    </div>
                                    {searchParams.searchText && (
                                        <div className="flex flex-column col-12">
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        </div>
                                    )}
                                </>
                            )
                        }

                        if(eachOption.type === "MULTISELECT"){
                            return (
                                <>  
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12 custom-multiselect">
                                        <MultiSelectField name="category" labelText={eachOption.label} options={materialCategories} value={searchParams[eachOption.name]} onChange={(event) => handleInputChange(event)} />
                                    </div>
                                </>
                            )
                        }
                        
                        // if (eachOption.type === "DATE") {
                        //     return (
                        //         <>  
                        //             <DateFilter
                        //                 eachOption={eachOption} 
                        //                 searchParams={searchParams} 
                        //                 dateOptions={["MTD", "PM", "L15", "L30"]}
                        //                 handleDateRangeChange={handleDateRangeChange} 
                        //                 handleSearchOnChange={handleSearchOnChange}
                        //                 removeFilterOption={removeFilterOption}
                        //             />
                        //         </>
                        //     )
                        // }
                        if(eachOption.type === "SELECT"){
                            const updatedOptions = eachOption.options.map(eachSelectOption => ({label: eachSelectOption.label, value: eachSelectOption.value}))
                            return (
                                <>
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name={eachOption.name} options={updatedOptions} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }
                    })
                }
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>
                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{cursor : isPageLoading ? 'not-allowed' : 'pointer'}}>
                            <Button label="Search" style={{flexGrow: 1}} className="py-2" onClick={handleSearch} disabled={isPageLoading}/>
                            {/* <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3"  onClick={(e) => downloadMenu.current.toggle(e)} /> */}
                        </div>
                    </div>
                </div>
            </div>
            <Loading visible={isLoaderVisible} />
        </div>
    )
}
export default MaterialPendingRequestSearchBar;